import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { getCurrentView } from '../selectors/ListPresentationSelector';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { jacketShape } from '@bibliocommons/bc-prop-types';

export class JacketCoverContainer extends BcReactComponent {
  render() {
    return this.props.currentView !== 'small' ? <JacketCover {...this.props} /> : null;
  }
}

JacketCoverContainer.propTypes = {
  currentView: PropTypes.string,
  format: PropTypes.string,
  src: PropTypes.oneOfType([
    PropTypes.string,
    jacketShape
  ]),
  size: PropTypes.string,
  responsive: PropTypes.bool,
  testId: PropTypes.string
};

const mapStateToProps = (state) => ({
  currentView: getCurrentView(state)
});

export default connect(mapStateToProps)(JacketCoverContainer);



// WEBPACK FOOTER //
// ./app/containers/JacketCoverContainer.jsx